import m from "../../../../../@vue_babel-helper-vue-jsx-merge-props@1.4.0/node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.js";
import i from "../../../../../@babel_runtime@7.25.6/node_modules/@babel/runtime/helpers/esm/extends.js";
import { isDef as u, noop as c } from "../utils/index.js";
import { inherit as s } from "../utils/functional.js";
import { preventDefault as f } from "../utils/dom/event.js";
import { createNamespace as d } from "../utils/create/index.js";
var a = d("overlay"),
  v = a[0],
  y = a[1];
function S(t) {
  f(t, !0);
}
function n(t, e, o, l) {
  var r = i({
    zIndex: e.zIndex
  }, e.customStyle);
  return u(e.duration) && (r.animationDuration = e.duration + "s"), t("transition", {
    attrs: {
      name: "van-fade"
    }
  }, [t("div", m([{
    directives: [{
      name: "show",
      value: e.show
    }],
    style: r,
    class: [y(), e.className],
    on: {
      touchmove: e.lockScroll ? S : c
    }
  }, s(l, !0)]), [o.default == null ? void 0 : o.default()])]);
}
n.props = {
  show: Boolean,
  zIndex: [Number, String],
  duration: [Number, String],
  className: null,
  customStyle: Object,
  lockScroll: {
    type: Boolean,
    default: !0
  }
};
var w = v(n);
export { w as default };
